{
  "fr": {
    "levels": {
      "actions": {
        "add_customer": "Ajouter Client",
        "cancel": "Annuler",
        "changeLevel": "Changer de niveau",
        "changeTargetGroup": "Changer Groupe Cible",
        "delete": "Supprimer",
        "removeCustomer": "Déconnecter le client",
        "requestUnits": "Demandez des unités",
        "save": "Enregistrer"
      },
      "building": "Bâtiment",
      "customers": "Clients",
      "descriptions": {
        "mupCantDelete": "Il semble que vous ayez encore des unités dans ce projet. Afin de supprimer le projet, nous vous recommandons de supprimer d'abord les unités. De cette manière, nous sommes sûrs à 100 % que le projet peut être supprimé.",
        "mupCantDeleteDeactivate": "Une alternative à la suppression du projet consiste à le désactiver. De cette manière, toutes les informations seront conservées pour une utilisation future. Voulez-vous désactiver ce projet ?"
      },
      "labels": {
        "activity": "Activité",
        "aftercare": "Après-vente",
        "allLevels": "Tout les niveaux",
        "contacts": "Contacts",
        "conversations": "Conversations",
        "decisions": "Décisions",
        "deleteProject": "Êtes-vous sûr de vouloir supprimer {project_name}",
        "deleteProjectDisclaimer": "La suppression de ce projet entraînera la perte définitive de toutes les données et de tout le contenu. Cette action est irréversible. Une autre solution consiste à désactiver le projet afin de préserver toutes les informations en vue d'une utilisation ultérieure. Procédez avec prudence.",
        "deleteWarning": "Attention! La suppression de ce niveau entraînera la suppression de tous les niveaux sous-jacents, documents, annonces, FAQ et tâches liés à ce niveau.",
        "documents": "Documents",
        "download": "Télécharger {level_name}",
        "generatingExport": "Générer export",
        "hide": "Cacher",
        "information": "Information",
        "installment": "Finances",
        "milestones": "Jalons",
        "multiple_selection": "Sélection multiple",
        "mupCantDelete": "Oh non, cette action n'est pas possible !",
        "needMoreUnits": "Besoin de plus d'unités?",
        "reachedMax": "Vous avez créé l'unité affectée à ce projet. | Vous avez atteint le {count} unités affectées à ce projet.",
        "reachedMaxRundle": "Vous avez atteint votre limite de 1 unité actives. | Vous avez atteint votre limite de {count} unités actives.",
        "requestMoreUnits": "Contactez l'équipe de Ziggu si vous souhaitez demander plus d'unités actives.",
        "settings": "Paramètres du projet",
        "sharedWith": "Partagé avec ",
        "showForLevel": "Montrer {object} pour le niveau",
        "spaces": "Espaces",
        "surveys": "Formulaires",
        "tickets": "Conversations",
        "todos": "Tâches",
        "todos_v2": "Tâches v2",
        "willBeAssigned": "Disponible pour tout le monde en ",
        "willBePublished": "Sera montré à tout le monde dans ",
        "willBeUploaded": "Sera téléchargé sur"
      },
      "lot": "Lot",
      "phase": "Phase",
      "project": "Projet",
      "tooltip": {
        "add_level": "Ajouter {level}"
      },
      "unit": "Unité"
    }
  }
}
